//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common'
import { ConvertHelper, DataProvider, TypeHelper } from '../../helpers'
import { OpDescr } from './op-descr'
import { OpOperator } from './op-operator'


export class OpTaskType implements IReferenceType, IOpChangeState, IJsonSerializable {

    // Properties

    public idTaskType: number
    public idTaskTypeGroup: number
    public idOperatorCreator: number
    public name: string
    public descr: number
    public durationEstimate: number
    public remote: boolean
    public creationDate: Date
    public authorized: boolean
    public imrOperator: boolean
    public code: string
    public color: string

    // Properties End


    // Navigation Properties

    public description: OpDescr
    public operatorCreator: OpOperator

    // Navigation Properties End


    // Custom Properties

    public dynamicValues: { Key: string, Value: any }[] = []

    // Custom Properties End
    

    // Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor End


    // IOpChangeState Implementation

    public opState: Enums.OpChangeState

    // IOpChangeState Implementation End


    // IReferenceType Implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdTaskType
    }

    public getReferenceKey(): number {
        return this.idTaskType
    }

    public getReferenceValue(): any {
        return this
    }

    // IReferenceType Implementation End


    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || TypeHelper.isJSONCompressed(opObj)) {
                this.idTaskType = opObj.I
                this.idTaskTypeGroup = opObj.IDT
                this.idOperatorCreator = opObj.IOC
                this.name = opObj.N
                this.descr = opObj.DE
                this.durationEstimate = opObj.DES
                this.remote = opObj.R
                this.creationDate = opObj.CD != null ? ConvertHelper.stringToDate(opObj.CD) : null
                this.authorized = opObj.A
                this.imrOperator = opObj.IO
                this.code = opObj.C
                this.color = opObj.CO

                this.description = opObj.D ? new OpDescr(opObj.D) : null
                this.operatorCreator = opObj.OC ? new OpOperator(opObj.OC) : null

                this.dynamicValues = opObj.DV

                this.opState = opObj.O
            } else {
                this.idTaskType = opObj.ID_TASK_TYPE
                this.idTaskTypeGroup = opObj.ID_TASK_TYPE_GROUP
                this.name = opObj.NAME
                this.descr = opObj.DESCR
                this.idOperatorCreator = opObj.ID_OPERATOR_CREATOR
                this.durationEstimate = opObj.DURATION_ESTIMATE
                this.remote = opObj.REMOTE
                this.authorized = opObj.AUTHORIZED
                this.imrOperator = opObj.IMR_OPERATOR
                this.code = opObj.CODE
                this.color = opObj.COLOR

                this.creationDate = opObj.CREATION_DATE != null ? ConvertHelper.stringToDate(opObj.CREATION_DATE) : null

                this.description = opObj._Description ? new OpDescr(opObj._Description) : null
                this.operatorCreator = opObj._OperatorCreator ? new OpOperator(opObj._OperatorCreator) : null

                this.dynamicValues = opObj.dynamicValues

                this.opState = opObj.OpState
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const result = {
                I: this.idTaskType,
                IDT: this.idTaskTypeGroup,
                IOC: this.idOperatorCreator,
                N: this.name,
                DE: this.descr,
                DES: this.durationEstimate,
                R: this.remote,
                A: this.authorized,
                IO: this.imrOperator,
                C: this.code,
                CO: this.color,

                CD: this.creationDate != null ? ConvertHelper.dateToString(this.creationDate, { netFormat: true }) : null,
                
                D: this.description != null ? this.description.toJSON(compressed) : null,
                OC: this.operatorCreator != null ? this.operatorCreator.toJSON(compressed): null,

                DV: this.dynamicValues,

                O: this.opState,
            }

            TypeHelper.setJSONCompressedFlag(result)

            return result
        }

        return {
            ID_TASK_TYPE: this.idTaskType,
            ID_TASK_TYPE_GROUP: this.idTaskTypeGroup,
            NAME: this.name,
            DESCR: this.descr,
            ID_OPERATOR_CREATOR: this.idOperatorCreator,
            DURATION_ESTIMATE: this.durationEstimate,
            REMOTE: this.remote,
            AUTHORIZED: this.authorized,
            IMR_OPERATOR: this.imrOperator,
            CODE: this.code,
            COLOR: this.color,

            CREATION_DATE: this.creationDate != null ? ConvertHelper.dateToString(this.creationDate, { netFormat: true }) : null,

            _Description: this.description != null ? this.description.toJSON(compressed) : null,
            _OperatorCreator: this.operatorCreator != null ? this.operatorCreator.toJSON(compressed): null,

            dynamicValues: this.dynamicValues,

            OpState: this.opState
        }
    }

    public toString(): string {
        if (this.description != null) {
            return this.description.description
        }

        return this.name
    }

    // IJsonSerializable Implementation End


    public static loadNavigationProperties(dataProvider: DataProvider, list: OpTaskType[]): JQueryPromise<OpTaskType[]> {
        const defered = $.Deferred<OpTaskType[]>()

        defered.resolve(list)

        return defered.promise()
    }

}